import { TagResponse, TagListResponse, TagDeleteResponse } from '../types/Product';
import { client } from '../utils/fetch';

const TAGS_ENDPOINT = 'tags';

export const fetchTags = async (): Promise<TagResponse[]> => {
  try {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const response = await client.get<TagListResponse>(TAGS_ENDPOINT, headers);
    return response.tags;
  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error;
  }
};

export const fetchTagsWithProductCount = async (): Promise<TagResponse[]> => {
  try {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const response = await client.get<TagListResponse>(`${TAGS_ENDPOINT}?include_product_count=true`, headers);
    return response.tags;
  } catch (error) {
    console.error('Error fetching tags with product count:', error);
    throw error;
  }
};

export const fetchTag = async (id: number): Promise<TagResponse> => {
  try {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const response = await client.get<TagResponse>(`${TAGS_ENDPOINT}/${id}`, headers);
    return response;
  } catch (error) {
    console.error('Error fetching tag:', error);
    throw error;
  }
};

export const createTag = async (name: string): Promise<TagResponse> => {
  try {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const body = { name };
    const response = await client.post<TagResponse>(TAGS_ENDPOINT, body, headers);
    return response;
  } catch (error) {
    console.error('Error creating tag:', error);
    throw error;
  }
};

export const updateTag = async (id: number, name: string): Promise<TagResponse> => {
  try {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const body = { name };
    const response = await client.put<TagResponse>(`${TAGS_ENDPOINT}/${id}`, body, headers);
    return response;
  } catch (error) {
    console.error('Error updating tag:', error);
    throw error;
  }
};

export const deleteTag = async (id: number): Promise<TagDeleteResponse> => {
  try {
    const response = await client.delete<TagDeleteResponse>(`${TAGS_ENDPOINT}/${id}`, {});
    return response;
  } catch (error) {
    console.error('Error deleting tag:', error);
    throw error;
  }
};